import { requestWithAuth } from "./http";

const API_BASE = "https://api.touchprop.com/api/v1/challenge";
const FALLBACK_MESSAGE = "??? ?? ?????? ???????";

const request = (path, options = {}) =>
  requestWithAuth(`${API_BASE}${path}`, options, { fallbackMessage: FALLBACK_MESSAGE });

export function getChallengesByMarket(market_type, broker_type, broker_scope) {
  const params = new URLSearchParams();
  if (broker_type) params.append("broker_type", broker_type);
  if (broker_scope) params.append("broker_scope", broker_scope);
  const query = params.toString();
  return request(`/list/${market_type}/${query ? `?${query}` : ""}`);
}

export function getAccountTypes({ market_type, stage_type, name, broker_type, broker_scope }) {
  const params = new URLSearchParams();
  params.append("market_type", market_type);
  params.append("stage_type", stage_type);
  if (name) params.append("name", name);
  if (broker_type) params.append("broker_type", broker_type);
  if (broker_scope) params.append("broker_scope", broker_scope);
  return request(`/account-types/?${params.toString()}`);
}

export function getPrice({ market_type, stage_type, account_type_number, balance, name, broker_type, broker_scope }) {
  const params = new URLSearchParams();
  params.append("market_type", market_type);
  params.append("stage_type", stage_type);
  params.append("account_type_number", account_type_number);
  params.append("balance", balance);
  if (name) params.append("name", name);
  if (broker_type) params.append("broker_type", broker_type);
  if (broker_scope) params.append("broker_scope", broker_scope);
  return request(`/price/?${params.toString()}`);
}
